import React from 'react'

import { COLORS } from '../Constants'
import { useStateValue } from './StateProvider'

const Modus = () => {
    const [, dispatch] = useStateValue()

    const changeColorMode = (darkmode) => {
        dispatch({
          type: 'UPDATE_DARKMODE',
          item: darkmode,
        })
    }

    return (
        <div className='modus'>
            <div className='btn left__selection ligth' onClick={() => changeColorMode(false)} style={{
                backgroundColor: COLORS.main_bg_color_light,
                color: COLORS.main_font_color_light
            }}>Light</div>
            <div className='btn dark left__selection' onClick={() => changeColorMode(true)} style={{
                backgroundColor: COLORS.main_bg_color_dark,
                color: COLORS.main_font_color_dark
            }}>Dark</div>
        </div>
    )
}

export default Modus